module.exports = __webpack_public_path__ + "static/broccoli-43709cd7c7fd657faa86a0a6988e6882.svg";